import { Component, Input, OnInit } from '@angular/core';
import { BaseComponent } from '@app/finxone-web-frontend/app/Modules/shared/widgets/base/base.component';
import { ConfigService } from '@app/finxone-web-frontend/app/lib/services/config-service/config-service.service';
import {
  FormActionState,
  FormActionType,
} from '@app/finxone-web-frontend/app/lib/state/form-submision.state';
import { FormActionTypeEnum } from '@finxone-platform/form-action';
import {
  baseCssConfigStyle,
  BaseCssProperties,
  ExchangeQuoteSummary,
  ProviderClass,
} from '@finxone-platform/shared/sys-config-types';
import { Select, Store } from '@ngxs/store';
import { Observable, Subject, take, takeUntil } from 'rxjs';
import Handlebars from 'handlebars';
import {
  buildHandleBarModel,
  GenericHandleBarModel,
} from '@app/finxone-web-frontend/app/lib/utils/template/model-builder.utils';
import { AutoDestroy } from '@finxone-platform/shared/base-types';
import { CountriesCurrenciesService } from '@app/finxone-web-frontend/app/lib/services/countries-currencies-service/countries-currencies.service';
import { IconCacheService } from '@finxone-platform/shared/services';
import { PageConfigurationProvider } from '@app/finxone-web-frontend/app/Modules/zones/page-configuration.provider';

@Component({
  standalone: false,
  selector: 'finxone-platform-exchange-quote-summary',
  templateUrl: './exchange-quote-summary.component.html',
})
export class ExchangeQuoteSummaryComponent extends BaseComponent implements OnInit {
  @AutoDestroy private destroy$: Subject<void> = new Subject<void>();
  @Input() childContentStyle: baseCssConfigStyle;
  @Select(FormActionState.getFormActionStateWithId(FormActionTypeEnum.EXCHANGE_QUOTE_SUMMARY))
  formActionExchangeQuoteSummary!: Observable<FormActionType | null>;

  private content = '';
  public renderedContent = '';
  private baseHandleBarModel: GenericHandleBarModel;
  public templateFunction: HandlebarsTemplateDelegate<any>;
  public exchangeQuoteSummary: ExchangeQuoteSummary;

  constructor(
    private configService: ConfigService,
    public dataIn: ProviderClass<any>,
    private store: Store,
    private countriesCurrenciesService: CountriesCurrenciesService,
    private iconCacheService: IconCacheService,
    public pageConfig: PageConfigurationProvider,
  ) {
    super();
  }

  ngOnInit() {
    if (this.dataIn) {
      this.attri = this.dataIn.attri ?? null;
    }

    this.contentStyle =
      this.childContentStyle ??
      this.configService.getSpecificBaseCssStyle(this.dataIn.attri, [
        BaseCssProperties.MARGIN,
        BaseCssProperties.PADDING,
        BaseCssProperties.BACKGROUND_COLOR,
        BaseCssProperties.BOX_SHADOW,
        BaseCssProperties.FONT_SIZE,
        BaseCssProperties.TEXT_FONT_STYLE,
        BaseCssProperties.COLOR,
        BaseCssProperties.BORDER,
      ]);

    if (!this.exchangeQuoteSummary) {
      this.formActionExchangeQuoteSummary.pipe(take(1)).subscribe((response) => {
        this.exchangeQuoteSummary = response?.formData;
        this.renderHandlebarTemplate();
      });
    }
  }

  private renderHandlebarTemplate() {
    this.content = this.attri?.widgetProperties?.textContent;
    this.templateFunction = Handlebars.compile(this.content);
    buildHandleBarModel(this.store, this.content, this.countriesCurrenciesService, this.iconCacheService)
      .pipe(takeUntil(this.destroy$))
      .subscribe((model) => {
        this.baseHandleBarModel = model;
        this.renderedContent = this.createTemplateData();
      });
  }

  private createTemplateData() {
    if (this.exchangeQuoteSummary) {
      return this.templateFunction({
        ...this.baseHandleBarModel,
        exchangeSummary: {
          ...this.exchangeQuoteSummary,
          feeAmountPlusSellAmount: this.exchangeQuoteSummary.feeAmount + this.exchangeQuoteSummary.sellAmount,
          buyAmountMinusFeeAmount: this.exchangeQuoteSummary.buyAmount - this.exchangeQuoteSummary.feeAmount,
        },
      });
    } else {
      return this.templateFunction({
        ...this.baseHandleBarModel,
      });
    }
  }
}
